export const REPORTS_TYPE_OPTIONS = [
  { id: 'user', value: 'User' },
  { id: 'form', value: 'Form' },
];

export const FORM_TYPE_OPTIONS = [
  { id: 'survey', value: 'Survey' },
  { id: 'other', value: 'Other' },
];

export const USER_TYPE_OPTIONS = [
  { id: 'member', value: 'Member' },
  { id: 'contact', value: 'Contact' },
];

export const CONTACT_TYPE_OPTIONS = {
  18: { id: 18, value: 'Patient' },
  36: { id: 36, value: 'Other' },
  22: { id: 22, value: 'Unknown' },
};

export const CONTACT_TYPE_OPTION_IDS = [18, 36, 22];

export const STATUS_OPTIONS = [
  { id: 'all', value: 'All' },
  { id: 'active', value: 'Active' },
  { id: 'deactivated', value: 'Deactivated' },
];
